
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class ExpertTipIconBase extends Vue {
  @Prop({ required: true, type: String })
  readonly src!: string
}
